import React, { useEffect, Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ContactUs from './components/ContactUs';
import CaseStudies from './components/CaseStudies';
import { initGA, trackPageView } from './services/analytics';
import GPTStorePitchPage from './pages/GPTStorePitchPage';
import IntercomComparisonPage from './pages/IntercomComparisonPage';
import NewPricingPage from './pages/NewPricingPage';
import Home1Page from './pages/Home1Page';
import Home2Page from './pages/Home2Page';
import Home3Page from './pages/Home3Page';
import Home4Page from './pages/Home4Page';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ThankYou from './components/ThankYou';
import SEOHead from './components/SEOHead';
import HebrewLandingPage from './platform/hebrew';
import GoogleTag from './components/GoogleTag';
import HotjarTag from './components/HotjarTag';
import MixpanelTag from './components/MixpanelTag';
import BlogIndex from './blog';
import ConversationNotifier from './components/ConversationNotifier';
import { I18nProvider } from './i18n/I18nProvider';
import LanguageSwitcher from './components/LanguageSwitcher';
import { useTranslation } from './i18n/useTranslation';
import './i18n/i18n'; // Import i18n initialization
import DeckMC from './deck/mc/index';
import StartNowBanner from './components/StartNowBanner';
// Page tracker component
const PageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
};
// SEO component to handle page-specific metadata
const PageSEO = () => {
  const location = useLocation();
  const path = location.pathname;
  let title = 'Shopilots | AI Shopping Advisors for Retailers';
  let description = 'Turn your product catalog into a conversational salesforce with AI shopping advisors that sell — not just chat. Deploy on your website, social media, WhatsApp, and ChatGPT. Contact info@shopilots.com today.';
  if (path === '/pricing') {
    title = 'ShoPilots Pricing - Plans That Grow With You';
    description = 'Start safe, scale selectively, and operate with confidence. 30-day free trial on all plans. No credit card required. Try before you pay with pleasure.';
  } else if (path === '/case_studies' || path === '/inspiration') {
    title = 'Case Studies | Shopilots AI Shopping Advisors';
    description = 'Discover how leading retailers use Shopilots AI shopping advisors to increase conversions, boost average order value, and enhance customer experience. Contact info@shopilots.com to learn more.';
  } else if (path === '/gpt-store') {
    title = 'GPT Store Solutions | Shopilots AI Shopping Advisors';
    description = 'Bring your brand into the AI era with a custom GPT Store that showcases your products and converts browsers into buyers. Contact info@shopilots.com for a consultation.';
  } else if (path === '/compare-to-intercom') {
    title = 'ShoPilots vs Intercom | The Smarter Choice for E-Commerce';
    description = 'See how ShoPilots delivers better conversions, simpler pricing, and an easier experience compared to Intercom. Save up to 70% with transparent pricing and proven results.';
  } else if (path === '/contact') {
    title = 'Contact Us | Shopilots AI Shopping Advisors';
    description = 'Get in touch with our team to learn how Shopilots can help your retail business leverage AI for increased sales and customer satisfaction. Email info@shopilots.com now.';
  } else if (path === '/blog') {
    title = 'AI Retail Blog | Shopilots AI Shopping Advisors';
    description = 'Latest insights, trends and strategies for implementing AI in retail and e-commerce to boost sales and enhance customer experience. Contact info@shopilots.com for AI retail solutions.';
  } else if (path === '/home2') {
    title = 'ShoPilots | The AI Shopping Agent for Retail';
    description = 'A unified AI agent for sales and support, fine-tuned for ecommerce brands and how their customers shop today. Start for free.';
  } else if (path === '/home3') {
    title = "ShoPilots | World's Leading AI-Powered eCommerce Platform";
    description = 'Empowering brands with AI-powered tools to build, personalize, test and optimize online experiences that drive growth. Fast, smart, and beautifully designed.';
  } else if (path === '/home4') {
    title = 'Shopilots | AI-Powered eCommerce Experimentation & Personalization';
    description = 'Test, personalize, and analyze with AI. Launch experiments, deliver 1:1 experiences, and measure real impact—all on one platform built for modern commerce teams.';
  } else if (path === '/terms-of-service' || path === '/terms-and-conditions') {
    title = 'Terms of Service | ShoPilots AI';
    description = 'Read our Terms of Service to understand your rights and responsibilities when using ShoPilots AI platform.';
  } else if (path === '/privacy-policy') {
    title = 'Privacy Policy | ShoPilots AI';
    description = 'Learn how ShoPilots AI collects, uses, and protects your personal information. Read our comprehensive privacy policy.';
  }
  return <SEOHead title={title} description={description} data-id="element-0" />;
};
// Main App Content Component that uses translations
const AppContent = () => {
  const {
    t
  } = useTranslation();
  return <div className="bg-background text-text min-h-screen" data-id="element-1">
      <GoogleTag data-id="element-2" />
      <HotjarTag data-id="element-3" />
      <MixpanelTag data-id="element-4" />
      <PageSEO data-id="element-5" />
      <PageTracker data-id="element-6" />
      <Navbar data-id="element-7" />
      <StartNowBanner data-id="element-8" />
      <Routes data-id="element-9">
        <Route path="/" element={<Home2Page data-id="element-11" />} data-id="element-10" />
        <Route path="/home1" element={<Home1Page data-id="element-13" />} data-id="element-12" />
        <Route path="/home2" element={<Home2Page data-id="element-15" />} data-id="element-14" />
        <Route path="/home3" element={<Home3Page data-id="element-17" />} data-id="element-16" />
        <Route path="/home4" element={<Home4Page data-id="element-19" />} data-id="element-18" />
        <Route path="/contact" element={<ContactUs data-id="element-21" />} data-id="element-20" />
        <Route path="/case_studies" element={<CaseStudies data-id="element-23" />} data-id="element-22" />
        <Route path="/inspiration" element={<CaseStudies data-id="element-25" />} data-id="element-24" />
        <Route path="/gpt-store" element={<GPTStorePitchPage data-id="element-27" />} data-id="element-26" />
        <Route path="/compare-to-intercom" element={<IntercomComparisonPage data-id="element-29" />} data-id="element-28" />
        <Route path="/thank-you" element={<ThankYou data-id="element-31" />} data-id="element-30" />
        <Route path="/pricing" element={<NewPricingPage data-id="element-33" />} data-id="element-32" />
        <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-35" />} data-id="element-34" />
        <Route path="/terms-and-conditions" element={<TermsOfServicePage data-id="element-37" />} data-id="element-36" />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-39" />} data-id="element-38" />
        <Route path="/hebrew" element={<HebrewLandingPage data-id="element-41" />} data-id="element-40" />
        <Route path="/blog/*" element={<BlogIndex data-id="element-43" />} data-id="element-42" />
        <Route path="/deck/mc" element={<DeckMC data-id="element-45" />} data-id="element-44" />
      </Routes>
      <Footer data-id="element-46" />
      <ConversationNotifier data-id="element-47" />
      <LanguageSwitcher data-id="element-48" />
    </div>;
};
export function App() {
  // Initialize Google Analytics
  useEffect(() => {
    initGA();
  }, []);
  // Ensure page starts at the top when loaded
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <BrowserRouter data-id="element-49">
      <I18nProvider data-id="element-50">
        <AppContent data-id="element-51" />
      </I18nProvider>
    </BrowserRouter>;
}